import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Stack } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { PropsWithChildren } from "react";

const ModalContent = ({
  children,
  label,
  onClose,
}: PropsWithChildren<{ label: string; onClose?: () => void }>) => (
  <Card
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: 600,
      width: { xs: "100%", sm: 600 },
      overflow: "auto",
      maxHeight: "80vh",
    }}
  >
    <CardContent>
      <Stack
        alignItems="start"
        flexDirection="row"
        justifyContent="space-between"
      >
        <Typography
          component="h2"
          id="modal-title"
          sx={{ marginBottom: "1em" }}
          variant="h5"
        >
          {label}
        </Typography>
        {onClose && (
          <IconButton aria-label="sluiten" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Stack>
      {children}
    </CardContent>
  </Card>
);

export default ModalContent;
